import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import { Drawer, List, ListItem, ListItemText, IconButton } from '@material-ui/core';

export default function TemporaryDrawer() {
    const [state, setState] = useState(false);
    const history = useHistory();

    async function GoTo(text) {
        if (text === 'Usuários') history.push("/users");
        else if (text === 'Controle de Chamadas') history.push("/calls");
        else if (text === 'Funções') history.push("/functions");
        else if (text === 'Contatos') history.push("/contacts");
        else if (text === 'Usinas') history.push("/usinas");
        else if (text === 'Tipos de Ocorrências') history.push("/occurrenceType");
        else if (text === 'Nível de Resposta') history.push("/nivelresp");
        else if (text === 'e-PAE') history.push("/pae");
    }

    return (
        <>
            <IconButton onClick={() => setState(true)}>
                <MenuIcon color="action" />
            </IconButton>
            <Drawer
                open={state}
                anchor={'left'}
                onClose={() => setState(false)}>
                <List>
                    {['Usuários', 'Controle de Chamadas', 'Funções', 'Contatos', 'Usinas', 'Tipos de Ocorrências', 'Nível de Resposta', 'e-PAE'].map((text, _) => (
                        <ListItem
                            button key={text}
                            onClick={() => { GoTo(text) }}
                        >
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </>
    );
}
